import { IDataset } from './dataset';
import { IRange } from './range';

export interface IPlot {
    datasets: IDataset[];
    range: IRange;
    state?: 'open' | 'closed' | 'collapsed' | 'expanded';
    plotId?: string;
    type?: string;

    // used for listing available plots, not used by the plots
    title?: string;
    description?: string;
}

export const DEFAULT_PLOT: IPlot =  {
    datasets: [],
    range: null,
    state: 'open'
};
